import React, { CSSProperties } from 'react';
import { useParams } from 'react-router-dom';

import { CircleAlert, Lock } from 'lucide-react';

import { useGetConversation, useGetScenarioWithPersonas } from '../../../hooks/mbts-ux';

import { EConversationMode } from '../../../types/entities.enum';

import { MBTSConversationWrapper } from '../../sub/mbts/ConversationWrapper';
import { MBTSChatConvoView } from '../../sub/mbts/ChatConvoView';
import { MBTSAudioConvoView } from '../../sub/mbts/AudioConvoView';
import { getScenarioColor } from '../../../helpers/misc.helper';

export const MBTSChat = () => {
    const { scenarioId, personaId, conversationId } = useParams();

    const { data: conversation, isLoading, error: conversationError } = useGetConversation(conversationId ?? null);
    const { data: scenarioDetails, error: scenarioError } = useGetScenarioWithPersonas(scenarioId ?? null);

    const oError = conversationError || scenarioError;
    const error = (oError as any)?.response?.data;
    const entitlementError =
        error?.statusCode === 403
            ? error.message || 'You are not entitled to access this conversation.'
            : null;

    console.log(error);

    return (
        <div
            className={`mbts_chat__page ${!isLoading && conversation && conversation.mode !== EConversationMode.CHAT && !entitlementError && !error ? 'mbts_chat__page--immersive' : ''}`}
            style={{
                '--scenario-theme-color-main': getScenarioColor(scenarioDetails ?? null).main,
                '--scenario-theme-color-bg': getScenarioColor(scenarioDetails ?? null).bg
            } as CSSProperties}
        >
            {isLoading && !conversation && !entitlementError && !error && (
                <div className='d-flex flex-column align-items-center justify-content-center gap-sm' style={{ flex: 1 }}>
                    <div className='list-loader' />
                    <p className='text-medium color--txt-secondary'>Loading conversation</p>
                </div>
            )}

            {!isLoading && !!entitlementError && (
                <div className='mbts_chat__top_sec'>
                    <div className='mbts_chat__top_sec__icon mbts_chat__top_sec__icon--locked'>
                        <Lock />
                    </div>
                    <p className='text-3xl text-bold mb-xs text-center'>Access Restricted</p>
                    <p className='color--txt-tertiary text-center'>{entitlementError}</p>
                </div>
            )}
            {!isLoading && !entitlementError && !!error && (
                <div className='mt-2xl d-flex flex-column align-items-center justify-content-center gap-sm'>
                    <CircleAlert className='color--error w-3xl h-3xl' />
                    <p className='text-2xl text-semibold text-center'>Error occurred</p>
                    <p className='color--txt-tertiary text-center'>{error?.message || 'An error occurred while loading the conversation.'}</p>
                </div>
            )}

            {!isLoading && !conversation && !entitlementError && !error && (
                <p className='text-lg text-semibold color--txt-tertiary text-center' style={{ margin: 'auto' }}>
                    Conversation not found!
                </p>
            )}
            {!isLoading && !!conversation && !entitlementError && !error && (
                <MBTSConversationWrapper
                    key={`${personaId}-${conversationId}`}
                    scenarioId={scenarioId ?? null}
                    personaId={personaId ?? null}
                    conversationId={conversationId ?? null}
                >
                    {
                        conversation.mode === EConversationMode.CHAT
                            ? <MBTSChatConvoView />
                            : <MBTSAudioConvoView />
                    }
                </MBTSConversationWrapper>
            )}
        </div>
    );
};
